import React from 'react';

import { UiKit } from 'components';
import Payer from './Payer';
import Fee from './Fee';

export default function Form({ isDisabled = false }) {
  return (
    <UiKit.Flex direction="column" gap="120">
      <Payer isDisabled={isDisabled} />
      <Fee isDisabled={isDisabled} />
    </UiKit.Flex>
  );
}
